import React from "react";

/**
 * TVScreenFrame: A reusable TV frame with fixed position and size.
 * Children are rendered inside the TV screen area.
 * Usage:
 *   <TVScreenFrame background="..."> ...screen content... </TVScreenFrame>
 */
function TVScreenFrame({ background = "/assets/walkthrough/no_screen_room.webp", children }) {
  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        background: `url(${background}) center center / cover no-repeat`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "50.25%",
          top: "40%", // slightly above center
          transform: "translate(-50%, -50%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "60vw",
          height: "34vw",
          maxWidth: 900,
          maxHeight: 510,
          minWidth: 320,
          minHeight: 180,
          background: "#222",
          borderRadius: "12px",
          boxShadow: "0 50px 100px 50px rgba(0,0,0,0.45), 0 1.5px 0 0 #444 inset, 0 -2px 16px 0 #000 inset",
          border: "8px solid #111",
          marginBottom: 32,
          zIndex: 2,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default TVScreenFrame;
